export default __webpack_public_path__ + "df19906c86edb22f5663808d55fd0bdd.woff";